import React from 'react';

import { ModelTable } from '../../components';
import { Column, Image } from '@smartplatform/ui';

const GalleryList = ({ rootPath, tabName }) => {
	const options = { order: 'publishAt DESC' };

	return (
		<ModelTable
			model="Gallery"
			options={options}
			rootPath={rootPath}
			path={'/admin/galleries/galleries'}
			tabName={tabName}
		>
			<Column property="name" label="Название" />
			<Column property="thumbnail" label="Миниатюра">
				<Image />
			</Column>
			<Column property="publishAt" label="Дата публикации" />
			<Column property="publish" label="Опубликовать" />
		</ModelTable>
	);
};

export default GalleryList;
